// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InstagramFilledSvg from "@fishx/icons-svg/es/asn/InstagramFilled";
import FishxIcon from '../components/FishxIcon';

var InstagramFilled = function InstagramFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InstagramFilledSvg
  }));
};

InstagramFilled.displayName = 'InstagramFilled';
export default React.forwardRef(InstagramFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InstagramFilled.js
// module id = 2979
// module chunks = 0